import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header-candidate.jsx";
import LeftMenu01 from "../../components/layout/leftMenu01.jsx";
import { FiAward, FiCalendar } from "react-icons/fi";
import { FaMapPin } from "react-icons/fa";
import { IoTimer } from "react-icons/io5";
import { useSelector } from "react-redux";
import { backendApi } from "../../api/apiService";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";
export default function CandidateDashboard() {
  const navigate=useNavigate();
  const { candidateData } = useSelector((state) => state.login);
  const[interviewList,setInterviewList]=useState([]);
  const[appliedList,setAppliedList]=useState([]);
  const[jobList,setJobList]=useState([]);
  const [jobSkills, setJobSkills] = useState([]);
  const[counts,setCounts]=useState({
    interviewCount:0,
    appliedCount:0,
    jobsCount:0,
    interviewTodayCount:0
  })

  useEffect(() => {
    candidateDashboadInit();
  }, []);

  const candidateDashboadInit = () => {
    var req = {
      functionName: "candidatedashboard_init",
      email_id: candidateData[0].email_id,
    };
    backendApi(req)
      .then((response) => {
        if (response.success === "1") {
          setInterviewList(response.interviewList);
          setAppliedList(response.appliedList);
          setJobList(response.jobsList);
          const countData=response.count.reduce((acc,item)=>{
            acc[item.name]=item.value;
            return acc;
          },{});
          const today = moment().startOf('day');
          const interviewsToday = response.interviewList.filter(interview => 
            moment(interview.start_date, "DD MMM YYYY hh:mm A").isSame(today, 'day')
          );
          setCounts({
            ...countData,
            interviewTodayCount: interviewsToday.length
          })
          const transformedOptions = response.skills.map((skill, index) => ({
            value: index + 1,
            label: skill.skill_name,
          }));
          setJobSkills(transformedOptions);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };

  const [menuClick, setMenuClick] = useState(false);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };
  const applyFunction = (data) => {
    navigate('/candidate-resume-upload',{
      state:{
        position:data,
        jobSkills:jobSkills
      }
    })
  };
  useEffect(() => {
    setTimeout(() => {
      document.getElementById("ResumeUploadMenu").classList.add("active");
    }, 500);
  }, []);
  return (
    <div className="main-wrapper">
      <div className="top-color"></div>
      <LeftMenu01 menuClick={menuClick} closeMenu={closeMenu} />
      <div className="content-wrapper">
        <Header
          Header="Candidate Dashboard"
          toggleMenu={toggleMenu}
          menuClick={menuClick}
        />
        <div className="main-container">
          <div className="row mb-3">
            <div className="col-xxl-3 col-lg-3 col-md-4">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="box_splite">
                    <div className="left_splite">
                      <h3 className="box-head">Job Listings</h3>
                      <p className="font-Medium text-lg">{counts.jobsCount}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-3 col-md-4">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="box_splite">
                    <div className="left_splite">
                      <h3 className="box-head">Interview Schedule</h3>
                      <p className="font-Medium text-lg">{counts.interviewCount}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-3 col-md-4">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="box_splite">
                    <div className="left_splite">
                      <h3 className="box-head">Applied Jobs</h3>
                      <p className="font-Medium text-lg">{counts.appliedCount}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-lg-3 col-md-4">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="box_splite">
                    <div className="left_splite">
                      <h3 className="box-head">Interview Today</h3>
                      <p className="font-Medium text-lg">{counts.interviewTodayCount}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-lg-6 col-md-12">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="main-heads py-2 mb-2">Interview Schedule</div>
                  <div class="table-responsive table-height">
                    <table class="table">
                      <thead>
                        <tr>
                          <th width="60px">Sl.No</th>
                          <th >Position</th>
                          <th width="100px">Time of Interview</th>
                          <th width="100px">Interview Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        {interviewList.map((interview,index) => (
                          <tr key={index}>
                            <td>{index+1}</td>
                            <td>{interview.summary}</td>
                            <td>
                              <div className="d-flex justify-content-center">
                                {/* <span>
                                  <IoTimer />
                                </span> */}
                                <span>{moment(interview.start_date, "DD MMM YYYY hh:mm A").format("DD/MM/YY hh:mm A")}</span>
                              </div>
                            </td>
                            <td>
                              <div className="text-primary cursor-pointer" >
                              {interview.interview_type === 'Online' ?
                               <div className="text-success">{interview.interview_type}</div> 
                               : 
                               <div className="text-danger">{interview.interview_type}</div> 
                               }
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="main-heads py-2 mb-2">Applied Jobs</div>
                  <div class="table-responsive table-height">
                    <table class="table">
                      <thead>
                        <tr>
                          <th width="60px">Sl.No</th>
                          <th width="150px">Position</th>
                          <th>Experience</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {appliedList.map((applied,index) => (
                          <tr key={index}>
                            <td>{index+1}</td>
                            <td>{applied.summary}</td>
                            <td>{applied.experiance} Years</td>
                            <td>
                              <div className="d-flex align-items-center">
                                <span>
                                  <FaMapPin color="#930d0d" fontSize={15} />
                                </span>
                                <span>{applied.location}</span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row cand-dashboard">
            {jobList.map((job)=>(
            <div className="col-lg-4 col-md-6 mb-3">
              <div className="card main-card-box">
                <div className="card-body">
                  <div className="">
                    <h4 className="job-view-header">{job.summary}</h4>
                    <p className="mb-2 job-para">
                      {job.description}
                    </p>
                    <div className="row">
                      <div className="col-6">
                        <div className="d-flex align-items-cener mb-2">
                          <span className="label-text">
                            <FiAward className="me-1" fontSize={18} />
                          </span>
                          <span className="font-Medium mt-1">{job.experiance} years</span>
                        </div>
                        <div className="d-flex align-items-cener mb-2">
                          <span className="label-text">
                            <FiCalendar className="me-1" title="posted on" fontSize={18} />
                          </span>
                          <span className="font-Medium mt-1">{moment(job.created_on).format("DD-MM-YY")}</span>
                        </div>
                      </div>
                      <div className="col-6 text-end mt-auto">
                        <div className="text-end">
                          <button className=" btn-btn btn btn-btn2" onClick={() => applyFunction(job)}>
                            Apply Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>))}          
          </div>
        </div>
      </div>
    </div>
  );
}
